import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-amber-600 flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                  <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
                </svg>
              </div>
              <div>
                <span className="text-xl font-bold text-white font-serif">Buy Fusion</span>
                <p className="text-xs text-stone-400 -mt-1">Premium Flooring Co.</p>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-6">
              Professional flooring installation services for residential and commercial properties. Quality craftsmanship you can trust.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-stone-400 hover:text-amber-500 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-stone-400 hover:text-amber-500 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-stone-400 hover:text-amber-500 transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-sm" data-testid="footer-link-home">Home</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm" data-testid="footer-link-services">Services</Link>
              </li>
              <li>
                <Link to="/about" className="footer-link text-sm" data-testid="footer-link-about">About Us</Link>
              </li>
              <li>
                <Link to="/service-areas" className="footer-link text-sm" data-testid="footer-link-areas">Service Areas</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link text-sm" data-testid="footer-link-contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="footer-link text-sm">Hardwood Flooring</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Vinyl Flooring</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Laminate Flooring</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Tile Flooring</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Carpet Installation</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Floor Repair</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+18888791244" className="text-white text-sm font-medium hover:text-amber-500 transition-colors">
                    +1-888-879-1244
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="mailto:support@buyfusion.store" className="text-stone-400 text-sm hover:text-amber-500 transition-colors">
                    support@buyfusion.store
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <span className="text-stone-400 text-sm">
                    88 Sunset Boulevard<br />
                    Los Angeles, CA 800134
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div className="text-stone-400 text-sm">
                  <p>Mon-Fri: 8:00 AM - 6:00 PM</p>
                  <p>Sat: 9:00 AM - 4:00 PM</p>
                  <p>Sun: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm">
              &copy; {currentYear} Buy Fusion - Premium Flooring Co. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/privacy-policy" className="footer-link text-sm" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms" className="footer-link text-sm" data-testid="footer-terms">Terms & Conditions</Link>
              <Link to="/disclaimer" className="footer-link text-sm" data-testid="footer-disclaimer">Disclaimer</Link>
              <Link to="/sitemap" className="footer-link text-sm" data-testid="footer-sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
